import { v2 } from '@saucelabs/sl-module-builds';

import { NAMESPACE } from './types';

export default v2.buildsDetail.actions.createVDCActions(NAMESPACE);
